import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Row,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import { FormInputItem, FormPasswordItem } from "../../components/formInput";
import { CreateDataOnServer, UpdateDateOnServer } from "../../lib/api";
import { OPERATOR_CREATE, OPERATOR_UPDATE } from "../../lib/config";
import { useSelector } from "react-redux";
import {
  EnvironmentOutlined,
  FieldNumberOutlined,
  KeyOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from "@ant-design/icons";
import toast from "react-hot-toast";
import { PERMISSION_CONST } from "../../lib/permissions";

const { Text } = Typography;
export default function OperatorForm({ edit, closeDrawer }) {
  const { access_token, csrf_token, ui_size, ...user } = useSelector(
    (state) => state.user
  );
  console.log("user....", user)
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [permissionError, setPermissionError] = useState(false);
  const [operatorCheck, setOperatorCheck] = useState([]);

  const [passwordError, setPasswordError] = useState(
    "Password must be at least 8 characters"
  );

  async function submitHandler(values) {
    setLoading(true);
    if (selectedPermissions.length === 0) {
      setPermissionError(true);
      setLoading(false);
      return;
    }

    const formattedVal = {
      ...values,
      permissions: selectedPermissions,
    };
    console.log("formattedVal...", formattedVal)
    const apiCall = edit
      ? UpdateDateOnServer(
          OPERATOR_UPDATE,
          edit.id,
          formattedVal,
          access_token,
          csrf_token
        )
      : CreateDataOnServer(
          OPERATOR_CREATE,
          formattedVal,
          access_token,
          csrf_token
        );

    apiCall
      .then(() => {
        toast.success(
          edit
            ? "Updated operator successfully"
            : "Created operator successfully"
        );
        setLoading(false);
        closeDrawer(true);
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error.message);
      });
  }

  const validatePassword = (_, value) => {
    if (!value) {
      return Promise.reject();
    }
    if (value.length < 8) {
      setPasswordError("Password must be at least 8 characters");
      return Promise.reject(
        new Error("Password must be at least 8 characters")
      );
    }
    setPasswordError("");
    return Promise.resolve();
  };

  const handlePermissionChange = (key, checked) => {
    setSelectedPermissions((prev) =>
      checked ? [...prev, key] : prev.filter((permi) => permi !== key)
    );

    if (permissionError && checked) {
      setPermissionError(false);
    }
  };

  const renderPermissions = () => (
    <Row gutter={[16, 16]}>
      {PERMISSION_CONST.map((item, index) => {
     
        const isOperatorsCard = item.label === "Operators";
        const isEditingOwnAccount = edit && edit.code === user.code;
        const shouldDisable = isOperatorsCard || isEditingOwnAccount;
        
        return (
          <Col key={`permission_${index}`} span={8}>
            <Card 
              style={{ 
                height: "100%", 
                ...(shouldDisable ? { 
                  opacity: 0.6, 
                  cursor: "not-allowed" 
                } : {}) 
              }} 
              title={item.label} 
              size={ui_size}
            >
              <Row gutter={[8, 8]}>
                {item.keys.map((key) => (
                  <Col span={24} key={`permission_key_${index}_${key.key}`}>
                    <Checkbox
                      checked={selectedPermissions.includes(key.key)}
                      onChange={(e) =>
                        handlePermissionChange(key.key, e.target.checked)
                      }
                      disabled={shouldDisable}
                    >
                      {key.name}
                    </Checkbox>
                  </Col>
                ))}
              </Row>
            </Card>
          </Col>
        );
      })}
    </Row>
  );
  useEffect(() => {
    if (edit) {
      form.setFieldsValue({
        name: edit.name,
      });
      setSelectedPermissions(edit.permissions || []);
    } else {
      form.resetFields();
      setSelectedPermissions([]);
    }
  }, [edit, form]);

  return (
    <Form
      size={ui_size}
      form={form}
      initialValues={edit ? edit : {}}
      onFinish={submitHandler}
      layout="vertical"
    >
      <Row gutter={[16, 0]}>
        <Col span={8}>
          <FormInputItem
            label="Name"
            name="name"
            placeholder="Name"
            rules={[{ required: true }]}
            icon={<UserOutlined />}
          />
        </Col>
        {!edit && (
          <Col span={8}>
            <FormInputItem
              label="Code"
              name="code"
              placeholder="Code"
              rules={[
                {
                  required: true,
                  max: 2,
                  message:
                    "Code must be shorter than or equal to two characters",
                },
              ]}
              icon={<FieldNumberOutlined />}
              onKeyDown={(e) => {
                if (!/[A-Z0-9]/i.test(e.key)) {
                  e.preventDefault();
                }
              }}
              normalize={(value) => value && value.toUpperCase()}

            />
          </Col>
        )}

        {!edit && (
          <Col span={8}>
            <FormPasswordItem
              label="Password"
              name="password"
              placeholder="Password"
              icon={<KeyOutlined />}
              rules={[{ required: true }, { validator: validatePassword }]}
              help={passwordError}
              validateStatus={passwordError ? "warning" : ""}
              hasFeedback
            />
          </Col>
        )}

        <Col span={8}>
          <FormInputItem
            label="Email"
            name="email"
            type="email"
            placeholder="Email"
            rules={[{ required: true }]}
            icon={<MailOutlined />}
          />
        </Col>
        <Col span={8}>
          <FormInputItem
            label="Phone"
            name="phone"
            placeholder="Phone"
            rules={[{ required: true }]}
            icon={<PhoneOutlined />}
          />
        </Col>
        <Col span={8}>
          <FormInputItem
            label="Address"
            name="address"
            placeholder="Address"
            icon={<EnvironmentOutlined />}
          />
        </Col>

        <Col span={24} style={{ marginTop: "20px" }}>
          <Text>Access Permissions</Text>
          <Col style={{ marginTop: "20px" }}>
            {renderPermissions()}
            {permissionError && (
              <Text type="danger">Please select at least one permission</Text>
            )}
          </Col>
        </Col>
      </Row>

      <Row>
        <Col span={24} align="right" style={{ marginTop: "24px" }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {edit ? "Update" : "Create"}
          </Button>
          <Button
            onClick={() => closeDrawer(false)}
            style={{ marginLeft: "16px" }}
          >
            Cancel
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
